import * as Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueSocialSharing from 'vue-social-sharing'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

const app = Vue.createApp(App)

app.use(store).use(router).use(VueAxios, axios).use(VueEasyLightbox).use(VueSocialSharing)
app.provide('axios', app.config.globalProperties.axios)  // provide 'axios'
app.mount('#app')
